import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import popupimage from "../../assets/popup.svg";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Image } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { StoreLocationAPI } from "../../Utils/Api/UserProfile";
import { userId } from "../../Utils/LocalStorage";
import { toast } from "react-toastify";
import { GetCity, GetState } from "../../Utils/Api/SignUP";
import ErrorLabel from "../ErrorLabel/ErrorLabel";
import Loader from "../Loader/Loader";
import AutoCompleteInput from "../AutoCompleteInput/AutoCompleteInput";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { RotatingLines } from "react-loader-spinner";

const AddLocationModal = ({ keyfuc, ...props }) => {
  const [locationData, setLocationData] = useState({}); //for creation
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [cityValue, setCityValue] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);

  // keyfuc(key);

  const navigate = useNavigate();

  const getState = async () => {
    const data = {
      country_id: 233,
    };
    const stateData = await GetState(data, () => {
      navigate("/");
    });
    setStateList(stateData.data);
  };

  const getCity = async (state_id) => {
    const dat = {
      state_id: state_id,
    };
    const cityData = await GetCity(dat, () => {
      navigate("/");
    });
    setCityList(cityData.data);
  };

  const CloseHandler = () => {
    setCityValue("");
    props.onHide();
  };

  const handleAddLocation = async () => {
    const d = {
      bu_id: Bu_id,
      sl_address: locationData.sl_address,
      sl_state: locationData.sl_state,
      sl_city: cityValue,
      sl_zipcode: locationData.sl_zipcode,
      api_method: "post",
    };

    const regex = /^[a-zA-Z0-9]*$/;

    if (
      d.sl_address === undefined ||
      cityValue === "" ||
      d.sl_state === undefined ||
      d.sl_zipcode === undefined ||
      !d.sl_zipcode ||
      !cityValue ||
      !d.sl_address ||
      !d.sl_state
    ) {
      setError("Please fill up all the fields");
    } else if (regex.test(d.sl_zipcode) === false) {
      setError("Please enter a valid zipcode!");
    } else {
      setBtnLoading(true);
      const addLocation = await StoreLocationAPI(d);
      if (addLocation === false) {
        toast.error(ServerError, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setBtnLoading(false);
      } else {
        if (addLocation.success === true) {
          keyfuc(!props.key);
          toast.success("Store Location Added", {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setBtnLoading(false);
          setError("");
          setLocationData({});
          props.show(false);
        } else if (addLocation.status === 429) {
          setLoading(true);
          toast.error(addLocation.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } else {
          toast.error(addLocation.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setBtnLoading(false);
        }
      }
    }
  };

  const Bu_id = userId();

  const CityInputHandler = (e) => {
    let val = e.target.value;
    setCityValue(val);
  };

  const handleChange = (e) => {
    if (e.target.name === "sl_state") {
      getCity(e.target.value);
      // console.log(e.target.value);
    }
    setError("");
    setLocationData({
      ...locationData,
      [e.target.name]: e.target.value,
    });
    // getCity(stateId);
  };
  const handleSend = (e) => {
    e.preventDefault();
    handleAddLocation();
  };

  useEffect(() => {
    getState();
  }, []);

  useEffect(() => {
    setCityValue("");
  }, [props.show]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="popup-modal"
      >
        <Modal.Header onClick={CloseHandler} closeButton></Modal.Header>
        <Modal.Body className="mb-5 edit-location-popup">
          <p className="text-center mb-3">
            {" "}
            <Image loading="lazy" src={popupimage} />
          </p>
          <p className="page-maintitle text-center">Add New Store Location</p>
          <Row>
            <Col md="12">
              <Form className="formmain mx-2 mt-4 signin-row profile-form pb-4">
                <Row>
                  <Col md="12" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Address Line <span className="star-required">* </span>
                      </Form.Label>

                      <InputGroup className="edit-border">
                        <Form.Control
                          type="text"
                          placeholder="Address Line"
                          className="custom-formcontrol"
                          maxLength={200}
                          name="sl_address"
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md="4" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        State / Province{" "}
                        <span className="star-required">* </span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Group className="mb-0" controlId="formBasicEmail">
                          <Form.Select
                            aria-label="Default select example"
                            className="custom-select edit-table-select"
                            name="sl_state"
                            onChange={handleChange}
                          >
                            <option>State/Province</option>
                            {stateList?.length > 0 ? (
                              stateList?.map((data) => {
                                return (
                                  <option
                                    value={data.state_id}
                                    key={data.state_id}
                                  >
                                    {data.state_name}
                                  </option>
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </Form.Select>
                        </Form.Group>
                      </InputGroup>
                    </Form.Group>
                  </Col>

                  <AutoCompleteInput
                    CityList={cityList}
                    EditFlag={true}
                    EditCity={cityValue}
                    ApiCity={""}
                    onCityFuc={CityInputHandler}
                    ErrDisplay={""}
                    NameFlag={"sl_city"}
                    Md={"4"}
                  />

                  {/* <Col md="4" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        City <span className="star-required">* </span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Group className="mb-0" controlId="formBasicEmail">
                          <Form.Select
                            aria-label="Default select example"
                            className="custom-select edit-table-select"
                            name="sl_city"
                            onChange={handleChange}
                            //   value={props.editInfo.city_name}
                          >
                            <option>City</option>
                            {cityList && cityList.length > 0 ? (
                              cityList.map((data) => {
                                return (
                                  <option
                                    value={data.mms_city_id}
                                    key={data.mms_city_id}
                                  >
                                    {data.city_name}
                                  </option>
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </Form.Select>
                        </Form.Group>
                      </InputGroup>
                    </Form.Group>
                  </Col> */}

                  <Col md="4" className="">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Zipcode <span className="star-required">* </span>
                      </Form.Label>

                      <InputGroup className="edit-border">
                        <Form.Control
                          type="text"
                          placeholder="Zipcode"
                          className="custom-formcontrol"
                          maxLength={10}
                          name="sl_zipcode"
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <center>
                    <ErrorLabel ErrorDisplay={error} />
                  </center>
                  <div className="text-center small-btns d-flex table-button-width">
                    <Link onClick={CloseHandler}>
                      <p className="view">Cancel</p>
                    </Link>
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3"
                      onClick={handleSend}
                    >
                      {btnLoading === true ? (
                        <RotatingLines
                          strokeColor="white"
                          width={20}
                          visible={true}
                        />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </div>
                </Row>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddLocationModal;
